<script>
	import { AppContext } from './Context.svelte';

	const colors = ['#399F9F', '#F6895A', '#714489', '#FFC000'];
	let ctx = AppContext.get();
</script>

<div class="g-legend">
	{#each ctx.donorTypeOrder as donorType, idx}
		<div class="g-legend-item">
			<div class="legend-circle" style:background-color={colors[idx]}></div>
			<div class="legend-text">{donorType}</div>
		</div>
	{/each}
</div>

<style>
	.g-legend {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 1em;
	}

	.g-legend-item {
		margin-right: 0.3em;
		display: flex;
		align-items: center;
	}

	.legend-circle {
		height: 16px;
		width: 16px;
		border-radius: 50%;
		margin-right: 0.3em;
	}
</style>
